import { createContext, useContext } from 'react';
import type { MutableRefObject } from 'react';

export interface ChromeLayout {
  /** The viewer is phone-width: compact buttons, docked panels. */
  narrow: boolean;
  /** The pointer is a finger: nothing may hide behind a hover. */
  coarse: boolean;
  /** How many of this viewer's menus and panels are open, so Esc closes those first. */
  openPopoversRef: MutableRefObject<number>;
}

export const ChromeContext = createContext<ChromeLayout>({
  narrow: false,
  coarse: false,
  openPopoversRef: { current: 0 },
});

export const useChromeLayout = (): ChromeLayout => useContext(ChromeContext);
